import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getGroupsActivityStore } from '../GroupsActivityStore';
import { type GroupActivityState, LoadState } from '../schema/GroupMemberRequestData';

export default function getGroupActivityState(mailboxInfo: MailboxInfo): GroupActivityState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const groupActivityState =
        getGroupsActivityStore().groupActivityStateByMailboxInfo.get(accountKey);

    if (!groupActivityState) {
        const defaultGroupActivityState: GroupActivityState = {
            memberRequestsData: [],
            loadState: LoadState.NotLoaded,
        };

        getGroupsActivityStore().groupActivityStateByMailboxInfo.set(
            accountKey,
            defaultGroupActivityState
        );
        return defaultGroupActivityState;
    }

    return groupActivityState;
}
